import React from "react";
import { Link } from "react-router-dom";
import dashboardImg from "../../assets/img/brochure/dashboard-panel.jpg";
import NetworkBackground from "../common/NetworkBackground";
import Reveal from "../common/Reveal";

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-primary-50 to-white">
      {/* 데이터 네트워크 배경 모션 */}
      <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
        <NetworkBackground className="absolute inset-0 h-full w-full" density={55} />
      </div>

      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:px-8 lg:py-24">
        {/* 텍스트 영역: 왼쪽에서 슬라이드인 */}
        <Reveal direction="right">
          <span className="inline-block rounded-full bg-primary-100 px-4 py-1.5 text-sm font-semibold tracking-wide text-primary-700">
            MANUFACTURING DATA &amp; AI SOLUTION COMPANY
          </span>
          <h1 className="mt-6 break-keep text-4xl font-bold leading-tight text-primary-900 sm:text-5xl">
            AI기반 제조업 혁신을
            <br />
            이끄는 최고의 파트너
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-gray-600">
            고객의 생산성과 운영 효율성을 극대화하기 위해 AI를 활용해서<br/>
            데이터 기반 제조 환경 스마트공장 솔루션 서비스를 제공합니다. <br/>
            IT와 제조업의 접점을 혁신하며 고객 맞춤형 솔루션을 통해 제조업<br/>혁신을 실현합니다.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link
              to="/technology"
              className="inline-flex items-center rounded-md bg-primary-800 px-6 py-3.5 text-base font-semibold text-white transition-all duration-200 hover:-translate-y-0.5 hover:bg-primary-700 hover:shadow-lg"
            >
              솔루션 살펴보기
            </Link>
            <a
              href="mailto:mtst@mtstech.kr"
              className="inline-flex items-center rounded-md border border-primary-200 bg-white px-6 py-3.5 text-base font-semibold text-primary-800 transition-all duration-200 hover:-translate-y-0.5 hover:bg-primary-50 hover:shadow-lg"
            >
              도입 문의
            </a>
          </div>
        </Reveal>

        {/* 이미지 영역: 오른쪽에서 슬라이드인 */}
        <Reveal direction="left" delay={150} className="relative">
          <div className="group overflow-hidden rounded-xl shadow-2xl ring-1 ring-black/5 transition-shadow duration-300 hover:shadow-primary-300/50">
            <img
              src={dashboardImg}
              alt="MT-ALL MES 대시보드"
              className="w-full transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        </Reveal>
      </div>
    </section>

  );
};

export default Hero;
